import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientSettingsPage from "@/pages/client/ClientSettingsPage";

export const Route = createFileRoute("/client/settings")({
  head: () => pageHead("Client · Settings", "AKIVA client · settings portal.", "/client/settings", true),
  component: ClientSettingsPage,
});
